/**
 * @fileoverview Zod schema for the Bulk Approve dialog.
 * @description One optional field, the review note recorded on every approval of the batch, within
 * the same length limit as a single decision's note. The message is a translation key, translated
 * at the display call site in BulkApproveDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

import { REVIEW_NOTE_MAX_LENGTH } from './reject-approval-form.schema'

/** @description The bulk-approve form's rules. */
export const bulkApproveFormSchema = z.object({
  reviewNote: z
    .string()
    .trim()
    .max(REVIEW_NOTE_MAX_LENGTH, 'sales.pipeline.bulkApprove.errors.noteTooLong'),
})

/** @description The bulk-approve form's values. */
export type BulkApproveFormValues = z.infer<typeof bulkApproveFormSchema>
